module.exports = __webpack_public_path__ + "static/media/usuarios.517d5c59.svg";